import { gql } from 'graphql-request'

export const USUARIO_BY_CPF_QUERY = gql`
  query UsuarioByCpfQuery($cpf: String!) {
    usuarioByCpf(cpf: $cpf) {
      id
      nome
      cpf
    }
  }
`
